import { Flex, Form } from 'dash-ui';
import AverageUnitValueInput from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/components/InventoryInfo/components/AverageUnitValueInput';

const BedroomBathroomRow = () => {
  return (
    <Form.Group w="100%" mt={3}>
      <Flex flex={1}>
        <Flex flex={1} flexDirection="column">
          <AverageUnitValueInput fieldKey="bedrooms" />
        </Flex>
        <Flex flex={1} flexDirection="column" ml={4}>
          <AverageUnitValueInput fieldKey="bathrooms" />
        </Flex>
      </Flex>
    </Form.Group>
  );
};

export default BedroomBathroomRow;
